"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAds = void 0;
const PublicConfig_1 = require("../../Config/PublicConfig");
class GoogleAds {
    init() {
        this.conversionId = (0, PublicConfig_1.publicConfig)().googleAds.conversionId;
        this.WhitelistedSingleValueEvents = {
            signupEmailEntry: "sJu9CPG5tI4DEJTA-6Uo",
            jobSearchStart: "0mL9CM6nwqMDEJTA-6Uo",
            signUpAccountCreation: "HhRCCM3uyqMDEJTA-6Uo",
            contactPageSubmission_demo: "G7OXCPm0qKMDEJTA-6Uo",
            signUpStart: "sJu9CPG5tI4DEJTA-6Uo",
            extensionPageChromeButtonClick: "bvvtCOrBvcwDEJTA-6Uo",
        };
        this.WhitelistedMultiValueEvents = {
            subscriptionStart: "bBj_CLqOgKQDEJTA-6Uo",
            subscriptionConfirmation: "S8V2CMCmgKQDEJTA-6Uo",
            subscriptionUpgradeStart: "TbaTCOzAgKQDEJTA-6Uo",
            topUpStart: "OWcSCI_DgKQDEJTA-6Uo",
            topUpConfirmation: "FnFNCMvGgKQDEJTA-6Uo",
            payPerUseStart: "uMN7CJPKgKQDEJTA-6Uo",
            subscriptionUpgradeConfirmation: "jMCvCNipsqQDEJTA-6Uo",
            payPerUseConfirmation: "InQXCLL5uKQDEJTA-6Uo",
        };
    }
    track(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (window.gtag) {
            if (event.name in this.WhitelistedSingleValueEvents) {
                window.gtag("event", "conversion", {
                    send_to: `${this.conversionId}/${(_a = this.WhitelistedSingleValueEvents[event.name]) !== null && _a !== void 0 ? _a : ""}`,
                });
            }
            if (event.name in this.WhitelistedMultiValueEvents) {
                window.gtag("event", "conversion", {
                    send_to: `${this.conversionId}/${(_b = this.WhitelistedMultiValueEvents[event.name]) !== null && _b !== void 0 ? _b : ""}`,
                    value: ((_c = event.properties) === null || _c === void 0 ? void 0 : _c["price"]) ? Number(event.properties["price"]) / 100 : 1.0,
                    currency: (_e = (_d = event.properties) === null || _d === void 0 ? void 0 : _d.currency) !== null && _e !== void 0 ? _e : "USD",
                    transaction_id: (_g = (_f = event.properties) === null || _f === void 0 ? void 0 : _f.transaction_id) !== null && _g !== void 0 ? _g : undefined,
                });
            }
        }
    }
}
exports.GoogleAds = GoogleAds;
//# sourceMappingURL=GoogleAds.js.map